import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format a leave-day count: always 2 decimal places.
// 1.75 -> "1.75", 5 -> "5.00", 2.5 -> "2.50", 1.7500001 -> "1.75".
export function formatDays(value) {
  if (value === null || value === undefined || value === '') return '0.00';
  const n = Number(value);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}
